export const DISCOVERY_TAGS = {
	CULTURE: '2791,2795,1159,5469,2811,3249,2891,3021,3023,1636,3160,1531,3164,3544,5256,2693,2679',
	FOOD: '2803,2826,5342,5497,3578,2594,2720,5466,2650',
	NATURE: '2805,2790,2724,3627,2901,5104,3167,2870,2871,5337',
	ANIME: '2786,3038,3250,3256,3156,1450,3253,2786,3252,3251,3527,5119,3039',
	WORKSHOP: '2801,3982,2598,5339,3037,5051,2688,2810,3239,3198,3121',
} as const;